// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const LayerIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg width={width} height={height} viewBox="0 0 24 22" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 5.51649V7.39591L2.89476 8.72633L0 10.0567V11.9362L2.904 13.2696L0 14.6051V16.4845L12 22L24 16.4845V14.6051L21.096 13.2696L24 11.9362V10.0567L21.1052 8.72633L24 7.39591V5.51649L12 0L0 5.51649ZM21.9571 15.5438L12 20.1155L2.04267 15.5438L4.94666 14.2093L12 17.4516L19.0531 14.2093L21.9571 15.5438ZM21.9571 10.9964L12 15.5682L2.04267 10.9964L4.93743 9.66502L11.9991 12.9114L19.0605 9.66502L21.9571 10.9964ZM21.9571 6.4562L12 11.0289L2.04267 6.4562L12 1.88348L21.9571 6.4562Z" fill="inherit"/>
        </svg>
      )
    }
  </Icon>
);

export default LayerIcon;
